<template>
  <div>
    <div class="family-version-container" v-loading="loadTree">
      <div class="family-version-wrapper">
        <div
          class="operation-item-wrap"
          v-for="item in versionList"
          :key="item.id"
        >
          <div class="operation-item flex">
            <div class="item-title">版本号：</div>
            <div>{{ item.id }}</div>
          </div>
          <div class="operation-item flex">
            <div class="item-title">操作用户：</div>
            <div>{{ operator.realName }}，{{ operator.name }}</div>
          </div>
          <div class="operation-item flex">
            <div class="item-title">操作设备：</div>
            <div>{{ initDeviceName(item.device) }}</div>
          </div>
          <div class="operation-item flex">
            <div class="item-title">操作时间：</div>
            <div>{{ item.create_time }}</div>
          </div>
          <div class="operation-item flex">
            <div class="item-title">操作名称：</div>
            <div>{{ initOperationName(item.action) }}</div>
          </div>
          <div class="operation-item flex">
            <div class="item-title">提交参数：</div>
            <div>
              <json-viewer :value="item.postParam"></json-viewer>
            </div>
          </div>
          <div class="operation-item">
            <OldFatherTree :treeData="item.father.data" :versionId="item.id" />
          </div>
          <div class="operation-item">
            <OldMotherTree :treeData="item.mother.data" :versionId="item.id" />
          </div>
          <div class="operation-item">
            <div class="item-parting-line"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="pagination-wrapper">
      <el-pagination
        layout="prev, pager, next"
        :total="versionCount"
        prev-text="上一页"
        next-text="下一页"
        hide-on-single-page
        :page-size="5"
        @prev-click="prevtListPageClick"
        @current-change="curtListPageClick"
        @next-click="nextListPageClick"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { apiMap } from "../utils/apiMap";
// import { birthToDate, formatDeadKey } from "../utils/feed";
// import $ from "jquery";
import _ from "lodash";
import qs from "qs";
import "vue-json-viewer/style.css";
import JsonView from "vue-json-viewer";
import OldFatherTree from "../components/user/version/old-father-tree";
import OldMotherTree from "../components/user/version/old-mother-tree";
export default {
  name: "clan-tree",
  data() {
    return {
      loadTree: true,
      versionList: [],
      operator: {},
      versionCount: 0,
    };
  },
  components: {
    JsonView,
    OldFatherTree,
    OldMotherTree,
  },
  mounted() {
    this.getVersionFamily(1);
  },
  methods: {
    getVersionFamily(start) {
      let _this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      if (loginUser) {
        let params = {
          token: loginUser.token,
          start: start,
          count: 5,
        };
        _this
          .$axios({
            baseURL: apiMap["commonUrl"],
            method: apiMap["versionFamily"]["method"],
            url: apiMap["versionFamily"]["url"],
            data: qs.stringify(params, { encode: false }),
          })
          .then(function(response) {
            _this.loadTree = false;
            if (response.data.result.statusCode == 1) {
              _this.versionList = response.data.result.data;
              _this.operator = response.data.result.userInfo;
              _this.versionCount = response.data.result.count;
            } else {
              _this.$message("获取家谱失败，稍后再试");
            }
          })
          .catch(function(error) {
            if (error.message.includes("Network")) {
              window.location.reload();
            }
          });
      } else {
        window.location = "/login";
      }
    },
    initDeviceName(data) {
      return data ? data : "未知";
    },
    initOperationName(data) {
      var nameMap = {
        unBindRelation: "断连操作",
        createRelation: "传连操作",
        createTempNode: "添加死亡操结点操作",
        removeTreeTempNode: "删除结点操作",
        updateTreeTempNode: "修改结点操作",
        copyUserFamily: "复制家谱操作",
      };
      if (nameMap[data]) {
        return `${data} => ${nameMap[data]}`;
      } else {
        return data;
      }
    },
    initTreeMap(data) {
      //setVersionTreeMap
      let treeMap = {};
      for (const i in data) {
        if (data[i].hasOwnProperty("id")) {
          const element = data[i];
          let fatherKey = `father-${data[i].id}`;
          let motherKey = `mother-${data[i].id}`;
          treeMap[fatherKey] = data[i]["father"]["data"];
          treeMap[motherKey] = data[i]["mother"]["data"];
        }
      }

      Store.dispatch("setVersionTreeMap", treeMap);
    },
    prevtListPageClick(newPage) {
      //即将加载的起始页
      this.getVersionFamily(newPage);
    },
    curtListPageClick(newPage) {
      //即将加载的起始页
      this.getVersionFamily(newPage);
    },
    nextListPageClick(newPage) {
      this.getVersionFamily(newPage);
    },
  },
};
</script>
<style>
.family-version-container {
  min-height: 60px;
  background-color: #fff;
}

.family-version-wrapper {
  width: 1001px;
}

.operation-item-wrap {
  margin-bottom: 5px;
  font-size: 16px;
}

.operation-item {
  margin: 8px 0 8px 15px;
}

.item-title {
  min-width: 80px;
}

.item-parting-line {
  width: 900px;
  border-bottom: 2px dashed #ff0000;
}

.tree-container {
  position: relative;
  min-width: 514px;
  height: auto;
  margin: 0 auto;
  overflow: auto;
  text-align: center;
}

.tree-canvas {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
}

.tree-container .child_box {
  width: inherit;
  position: relative;
  height: 32px;
  padding: 30px 0;
  margin: 0 auto;
  white-space: nowrap;
  z-index: 3;
}

.tree-container div a {
  display: inline-block;
  width: 80px;
  height: 30px;
  margin: 0 10px;
  font-size: 14px;
  border: 1px solid #000000;
  border-radius: 5px;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 30px;
  color: #333333;
}

.pagination-wrapper {
  background-color: #fff;
}

.pagination-wrapper div {
  width: 1001px;
  padding: 10px;
  text-align: center;
}
</style>
